module.exports = __webpack_public_path__ + "img/invoicelogo.df88340a.png";